import React, {useEffect, useState} from "react";
import Hero from "./Hero";
import Selection from "./Selection";
import Popular from "./Popular";
import Discover from "./Discover";
import Description from "./Description";
import {get} from "../../adapters/api";

const Home = () => {

    const [data, setData] = useState();

    useEffect(() => {
        (async () => {
            const info = await get('token/list');
            if (info.data) setData(info.data);
        })();

    }, []) //on initial render

    return (
        <>
            {data && <Hero items={data.newest} users={data.users}/>}
            {data && <Selection items={data.expensive} newest={data.lastPurchases} users={data.users}/>}
            {data && <Popular items={data.summaryByPurchase} users={data.users}/>}
            <Discover/>
            {/*<Description/>*/}
        </>
    );
};

export default Home;
